/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';


export default class Anchor extends Entity
{
  getID ()
  {
    return this.cass.sourceColony + ':' + this.cass.targetColony;
  }


};
